module.exports = __webpack_public_path__ + "img/40_49.63adc3df.png";